// El rol global concede permisos; las asignaciones sólo delimitan los activos.
export const canManageAssignments = user => {
  const role = typeof user?.role === 'string' ? user.role.trim().toLowerCase() : '';
  return role === 'admin' || role === 'superadmin';
};

export const canViewServicer = user => {
  const role = typeof user?.role === 'string' ? user.role.trim().toLowerCase() : '';
  return ['superadmin', 'admin', 'gestor'].includes(role);
};

export const canViewAssetSupplier = (user, asset) => {
  const role = typeof user?.role === 'string' ? user.role.trim().toLowerCase() : '';
  if (role === 'admin' || role === 'superadmin') return true;
  if (role !== 'gestor' || !user?.id || !asset) return false;
  // Mismo alcance de asignación que _apply_asset_role_scope en el servidor.
  return ['gestores', 'mediadores', 'inversores'].some(field =>
    Array.isArray(asset[field]) && asset[field].includes(user.id)
  );
};